<script lang="ts">
  import type { RetailerType } from "@shared/types/Retailer";
  import HomePage from "@retailer/svelte/ProductLines/Index/HomePage.svelte";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { convertParamsToStateParams } from "@modern/services/angularjs_shims/state_params";
  import retailerContext from "@modern/services/retailer_context";
  import { params } from "@roxi/routify";
  import distributorsServiceFactory from "@shared/services/distributors";
  import { getProductIndexBanners } from "@shared/services/banner_service";
  import qService from "@modern/services/angularjs_shims/q_service";
  import flashFactory from "@shared/services/flash";
  import { getControlStateAuthenticationService } from "@retailer/services/retailer_user_authentications_service";

  const Distributors = distributorsServiceFactory(null, flashFactory(), qService);

  let retailer: RetailerType = retailerContext.get();

  const authService = getControlStateAuthenticationService();

  const discoveryPanelRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: "/api/retailer/discovery_panel/discovery_config",
        data: { page_name: "home", page_value: null },
      });
      return res;
    } catch (e) {
      return [];
    }
  };

  const distributorsRes = async () => {
    let res = [];
    res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_cutoff_time: true,
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
      },
    }).catch(() => (res = []));
    DistributorsStore.set(res);
    return res;
  };

  const load = async () => {
    const promises1 = [distributorsRes(), discoveryPanelRes(), getProductIndexBanners("home")];

    let results1 = await Promise.all(promises1);

    return {
      distributors: results1[0],
      discoveryPanel: results1[1],
      productIndexBanners: results1[2] || [],
    };
  };
</script>

{#await load()}
  <Spinner />
{:then data}
  <HomePage
    {retailer}
    stateParams={convertParamsToStateParams($params)}
    discoveryPanelRes={data.discoveryPanel}
    productIndexBannersRes={data.productIndexBanners}
    {Distributors}
  />
  {#if authService?.authenticationModalComponent}
    <svelte:component this={authService?.authenticationModalComponent} />
  {/if}
{/await}
